import React from 'react'
import ListVacancies from '../../../react4xp/components/ListVacancies'

import dayjs from 'dayjs';

function ListVacanciesPart({ tag, title, noPositionsTitle, noPositionsIntro, vacancies, bottomHeading, buttons, componentId }) {
  return (
    <ListVacancies
      componentId={componentId}
      tagline={tag}
      title={{
        hasPositions: title,
        noPositions: noPositionsTitle
      }}
      positions={vacancies?.map(vacancy => {
        return {
          title: vacancy.position,
          position: vacancy.officeName,
          details: vacancy.applicationDue && dayjs(vacancy.applicationDue).isValid() && `<p>${dayjs(vacancy.applicationDue).format('DD MMMM YYYY')}</p>`,
          link: vacancy.link,
          isExternal: true
        }
      })}
      noPositionsText={`<p>${noPositionsIntro}</p>`}
      bottomHeading={bottomHeading}
      buttons={buttons?.map(link => {
        return {
          text: link.text,
          url: link.link,
          external: true
        }
      })}
    />
  )
}

export default (props) => <ListVacanciesPart {...props} />
